import React from "react";
// Chakra imports
import { Flex, Image, Box, useColorModeValue } from "@chakra-ui/react";
// Custom components
import { HSeparator } from "../../../components/separator/Separator.jsx";

const lightLogo = "/businessLogoNew.png";

export function SidebarBrand() {
  
  const logoSrc = useColorModeValue(lightLogo, lightLogo); 
  const separatorColor = useColorModeValue("#364fab", "#364fab"); 

  return (
    <Flex align="center" direction="column" py="20px" px="16px">
      <Image
        src={logoSrc}
        alt="Menom Logo"
        maxW="180px"
        maxH="120px"
        objectFit="contain"
      />
      {/* HSeparator */}
      <Box display={{ base: "none", xl: "block" }} w="100%">
        <HSeparator mt="16px" mb="16px" borderColor={separatorColor} />
      </Box>
    </Flex>
  );
}

export default SidebarBrand;